import React from "react"
import { Menu, X } from "lucide-react"

/**
 * @param {{
 *   logoSrc: string,
 *   logoAlt?: string,
 *   title: string,
 *   menuOpen: boolean,
 *   onToggleMenu: () => void,
 *   trailingActions?: React.ReactNode,
 * }} props
 */
export function MobileTopBar({
    logoSrc,
    logoAlt = "",
    title,
    menuOpen,
    onToggleMenu,
    trailingActions = null,
}) {
    return (
        <div
            className="d-lg-none position-sticky top-0 w-100"
            style={{ backgroundColor: "#0f6170", zIndex: 1030 }}
        >
            <div
                className="d-flex align-items-center justify-content-between px-3"
                style={{ height: "64px" }}
            >
                <div className="d-flex align-items-center min-w-0 me-2">
                    <img
                        src={logoSrc}
                        alt={logoAlt}
                        className="h-auto flex-shrink-0"
                        style={{ width: "2.5rem", height: "auto" }}
                    />
                    <span className="ms-2 text-white fw-semibold text-truncate">{title}</span>
                </div>

                <div className="d-flex align-items-center gap-2 flex-shrink-0">
                    {trailingActions}
                    <button
                        type="button"
                        onClick={onToggleMenu}
                        className="btn p-2 text-white"
                        style={{ lineHeight: 1 }}
                        aria-label={menuOpen ? "Close menu" : "Open menu"}
                    >
                        {menuOpen ? <X size={24} /> : <Menu size={24} />}
                    </button>
                </div>
            </div>
        </div>
    )
}
